// auth9.reducer.ts
import { createReducer, on } from '@ngrx/store';
import { AuthenticatedUserDto } from '@shared/models/authenticated-user.dto';
import { reset, set, update } from './auth9.actions';

export interface StateAuth9Type {
  auth9user: AuthenticatedUserDto | null;
}

export const initialState: StateAuth9Type = {
  auth9user: null,
};

export const auth9Reducer = createReducer(
  initialState,
  on(set, (state, { user }) => ({
    ...state,
    auth9user: user,
  })),
  on(update, (state, { user }) => ({
    ...state,
    auth9user: user,
  })),
  on(reset, (_) => initialState),
);
